export default __webpack_public_path__ + "static/media/Mumbai.a682f186.svg";